// @flow

import ApiError from 'PMT/entities/ApiError'
import ApiCartModifier from 'PMT/api/ApiCartModifier'
import AppDispatcher from 'PMT/flux/AppDispatcher'

import ActionTypes from 'constants/ActionTypes'

export default class CartModifierAction {

  static loadCartModifiers(restaurantId) {
    AppDispatcher.handleServerAction({
      type: ActionTypes.GET_CART_MODIFIERS,
    })

    ApiCartModifier.getCartModifiers(
      restaurantId,
      CartModifierAction.receiveCartModifiers,
      CartModifierAction.receiveCartModifiersError
    )
  }

  static receiveCartModifiers(data) {
    AppDispatcher.handleServerAction({
      type: ActionTypes.GET_CART_MODIFIERS_SUCCESS,
      data
    })
  }

  static receiveCartModifiersError(apiError: ApiError) {
    AppDispatcher.handleServerAction({
      type: ActionTypes.GET_CART_MODIFIERS_FAILURE,
      apiError
    })
  }

  static loadCartModifier(restaurantId, cartModifierId) {
    AppDispatcher.handleServerAction({
      type: ActionTypes.GET_CART_MODIFIER,
    })

    ApiCartModifier.getCartModifier(
      restaurantId,
      cartModifierId,
      (cartModifier) => {
        AppDispatcher.handleServerAction({
          type: ActionTypes.GET_CART_MODIFIER_SUCCESS,
          data: cartModifier,
        })
      },
      (apiError: ApiError) => {
        AppDispatcher.handleServerAction({
          type: ActionTypes.GET_CART_MODIFIER_FAILURE,
          apiError
        })
      }
    )
  }

  static putCartModifier(restaurantId, cartModifier) {
    AppDispatcher.handleServerAction({
      type: ActionTypes.PUT_CART_MODIFIER,
      restaurantId,
      cartModifier,
    })

    ApiCartModifier.putCartModifier(
      restaurantId,
      cartModifier,
      (updatedCartModifier) => {
        AppDispatcher.handleServerAction({
          type: ActionTypes.PUT_CART_MODIFIER_SUCCESS,
          data: updatedCartModifier,
        })
      },
      (apiError: ApiError) => {
        AppDispatcher.handleServerAction({
          type: ActionTypes.PUT_CART_MODIFIER_FAILURE,
          apiError
        })
      }
    )
  }

  static postCartModifier(restaurantId, cartModifier) {
    AppDispatcher.handleServerAction({
      type: ActionTypes.POST_CART_MODIFIER,
      restaurantId,
      cartModifier,
    })

    ApiCartModifier.postCartModifier(
      restaurantId,
      cartModifier,
      (createdCartModifier) => {
        AppDispatcher.handleServerAction({
          type: ActionTypes.POST_CART_MODIFIER_SUCCESS,
          data: createdCartModifier,
        })
      },
      (apiError: ApiError) => {
        AppDispatcher.handleServerAction({
          type: ActionTypes.POST_CART_MODIFIER_FAILURE,
          apiError
        })
      }
    )
  }

  static putCartModifiersPriorities(restaurantId, cartModifiersIds) {
    AppDispatcher.handleServerAction({
      type: ActionTypes.PUT_CART_MODIFIERS_PRIORITIES,
      restaurantId,
      cartModifiersIds,
    })

    ApiCartModifier.putCartModifiersPriorities(
      restaurantId,
      cartModifiersIds,
      (list) => {
        AppDispatcher.handleServerAction({
          type: ActionTypes.PUT_CART_MODIFIERS_PRIORITIES_SUCCESS,
          data: list,
        })
      },
      (apiError: ApiError) => {
        AppDispatcher.handleServerAction({
          type: ActionTypes.PUT_CART_MODIFIERS_PRIORITIES_FAILURE,
          apiError
        })
      }
    )
  }

}
